import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder } from '@angular/forms';

import { TidySelectNumberValueModel } from 'src/models/tidy-select-item.model';
import { AddressModel } from 'src/models/address.model';
import { Client } from 'src/providers/client/client';
import { OnboardingProvider } from 'src/providers/onboarding/onboarding.provider';
import { ToDos } from 'src/providers/to-dos/to-dos';

import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { WindowService } from 'src/shared/providers/window.service';
import { Util } from 'src/shared/util/util';
import { OnboardingDummyDataService } from 'src/shared/services/onboarding-dummy-data.service';
import { OnboardingComponent } from 'src/shared/components/onboarding/onboarding';

@Component({
    selector: 'popular-list-modal-onboarding',
    templateUrl: './popular-list.component.html',
    styleUrls: ['./popular-list.component.scss'],
    standalone: false
})
export class PopularListModalOnboardingComponent implements OnInit {
  forms: FormArray;
  roomOptions: TidySelectNumberValueModel[];
  floorOptions: TidySelectNumberValueModel[];
  addresses: AddressModel[];

  
  boundSave = this.save.bind(this);

constructor(
    private client: Client,
    private formBuilder: FormBuilder,
    private onboardingDummyData: OnboardingDummyDataService,
    private onboardingProvider: OnboardingProvider,
    private storage: TidyStorage,
    private toDos: ToDos,
    private util: Util,
    private rightSidePanelService: RightSidePanelService,
    public windowService: WindowService
  ) {}

  async ngOnInit() {
    this.forms = new FormArray([]);
    this.roomOptions = this.buildOptions(10);
    this.floorOptions = this.buildOptions(5);
    this.addresses = await this.client.getAddresses();
    this.initializeForms();
  }

  initializeForms() {
    const roomDefaults = this.onboardingDummyData.getRoomDefaults();
    this.addresses.forEach((address) => {
      this.forms.push(
        this.formBuilder.group({
          addressId: [address.id],
          addressName: [address.address_name],
          beds: [roomDefaults.beds],
          baths: [roomDefaults.baths],
          floors: [roomDefaults.floors],
        })
      );
    });
  }

  buildOptions(maxNumber: number): TidySelectNumberValueModel[] {
    return Array.from({ length: maxNumber }, (_, i) => ({
      viewValue: `${i + 1}`,
      value: i + 1,
    }));
  }

  async save() {
    try {
      await this.onboardingProvider.markGoalAsCompleted('toDos');
      this.rightSidePanelService.setDialogPageTitle('Getting Started');
      this.rightSidePanelService.navigateTo('onboarding', {}, OnboardingComponent);
      this.onboardingProvider.setShowOnboardingInHeader(true);
    } catch (err) {
      this.util.showError((err.error && err.error.message) ? err.error.message : err.message, 10000);
    }
  }
  
}
